import TradeshowService from '~/services/tradeshow.service';
import { EXPENSES } from '~/lib/constants';
import { gameSelectors, uiActions, productsActions, loadingActions } from '~/store';
// --- internal imports ------

import * as types from './actionTypes';
import * as tradeshowSelectors from './selectors';
import { setLocalStore } from '../../lib/helpers';
import { inboxActions } from '../store';
import { UI_FETCHING_NETWORK_REQUEST } from '~/store/ui/actionTypes';
// --- local imports ------

const loadTradeshow =
	(state) => (booth) =>
		(booth.tradeshow = tradeshowSelectors.getTradeshowById(state, booth.tradeshow?.id));

export function fetchAll() {
	return async (dispatch) => {
		const result = await TradeshowService.fetchAll();
		if (!result.isSuccess) {
			return;
		}

		const allTradeshows = result.data;

		dispatch({ type: types.TRADESHOW_FETCHED_ALL, allTradeshows });
	};
}

export function fetchHiredBooths() {
	return async (dispatch, getState) => {
		const gameUserId = gameSelectors.getGameId(getState());
		const result =  await TradeshowService.fetchHired(gameUserId);
		if (!result.isSuccess) {
			return;
		}

		const hiredTradeshowBooths = result.data;

		hiredTradeshowBooths.forEach(loadTradeshow(getState()));

		dispatch({ type: types.TRADESHOW_FETCHED_HIRED, hiredTradeshowBooths });
	};
}

export function hire(tradeshowId) {
	return async (dispatch, getState) => {
		const gameUserId = gameSelectors.getGameId(getState());

		dispatch(loadingActions.start(types.TRADESHOW_HIRE));

		const result = await TradeshowService.hire(tradeshowId, gameUserId);
		if (!result.isSuccess) {
			dispatch(loadingActions.endAfterNetworkFaliures());
			return false;
		}

		dispatch(loadingActions.end(types.TRADESHOW_HIRE));
		const { hiredTradeshowBooth, notifications } = result.data;

		loadTradeshow(getState())(hiredTradeshowBooth);
		dispatch(inboxActions.handleNewMessage(notifications));
		dispatch({ type: types.TRADESHOW_HIRE, hiredTradeshowBooth });
		dispatch(
			uiActions.addNewExpenseToDisplay(EXPENSES.TRADESHOW, hiredTradeshowBooth.payedPrice)
		);

		return true;
	};
}

export function start(tradeshowCustomers) {
	setLocalStore('screen', 'tradeshow');
	return { type: types.TRADESHOW_STARTED, tradeshowCustomers };
}

export function end() {
	return async (dispatch, getState) => {
		setLocalStore('screen', 'store');

		dispatch( { type: types.TRADESHOW_ENDED });
		dispatch(productsActions.resetProductMonthlySales());	//	Reset sales for salesman graph
	};
}
